import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IDataInput, IKnowladgeGraphDifferencesRow } from '../../../../../../interface/interfaces';

interface IInitialState {
    knowladgeGraphDiffLoading: boolean;
    knowladgeGraphDiffData: IKnowladgeGraphDifferencesRow;
    knowladgeGraphDiffError: string;
}

const knowladgeGraphInitialValues: IKnowladgeGraphDifferencesRow = {
    metadata: {
        file_url: '',
    },
    new_instances: [],
    changed_instances: [],
};

const initialState: IInitialState = {
    knowladgeGraphDiffLoading: false,
    knowladgeGraphDiffData: knowladgeGraphInitialValues,
    knowladgeGraphDiffError: '',
};

const knowladgeGraphDiffSlice = createSlice({
    name: 'knowladgeGraphDiff',
    initialState,
    reducers: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        fetchKnowladgeGraphDiffPending: (state: IInitialState, action: PayloadAction<IDataInput>) => {
            state.knowladgeGraphDiffLoading = true;
            state.knowladgeGraphDiffData = knowladgeGraphInitialValues;
        },

        fetchKnowladgeGraphDiffFulfilled: (state: IInitialState, action: PayloadAction<IKnowladgeGraphDifferencesRow>) => {
            state.knowladgeGraphDiffLoading = false;
            state.knowladgeGraphDiffData = action.payload;
            state.knowladgeGraphDiffError = '';
        },

        fetchKnowladgeGraphDiffFailure: (state: IInitialState, action: PayloadAction<string>) => {
            state.knowladgeGraphDiffLoading = false;
            state.knowladgeGraphDiffData = knowladgeGraphInitialValues;
            state.knowladgeGraphDiffError = action.payload;
        },
    },
});

export default knowladgeGraphDiffSlice.reducer;
export const { fetchKnowladgeGraphDiffPending, fetchKnowladgeGraphDiffFulfilled, fetchKnowladgeGraphDiffFailure } = knowladgeGraphDiffSlice.actions;
